import { render, staticRenderFns } from "./bindRealCard.vue?vue&type=template&id=8709a8d0&"
import script from "./bindRealCard.vue?vue&type=script&lang=js&"
export * from "./bindRealCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports